<div class="page-heading">
    <div class="page-heading-blue row p-4">
        <div class="col-5">
            <span>{{'CHANNEL' | translate}}
                <i class="fal fa-angle-right mr-1"></i>{{'ENTRY-RULES' | translate}}
            </span>
            <div class="header-timestamp">
                <h2 *ngIf="isValidChannel">{{channel.name}}</h2>
                <span>{{'VERSION' | translate}}: </span>
                <b *ngIf="isValidChannel">{{channel.version}}</b>
                <span class="ml-3">{{'LAST-SAVED' | translate}}: </span>
                <b *ngIf="isValidChannel">{{channel.lastModifiedOn | date:'medium'}}</b>
            </div>
        </div>
        <div class="col-5" *ngIf="isValidChannel">
            {{channel.description}}
        </div>
        <div class="col-2 my-auto">
            <button class="btn btn-outline-light mt-2 float-right" (click)="backToChannelEdit()">
                {{'BACK-TO-CHANNEL-EDIT' | translate}}
                <i class="arrow fal fa-angle-right"></i>
            </button>
        </div>
    </div>
</div>

<div *ngIf="isValidChannel">
    <div class="content-background-white">
        <div class="k-text-uppercase dark mb-2 font-weight-bold">{{'RULE-PREVIEW' | translate}}
            <span class="k-text-uppercase dark mb-2 font-weight-bold" *ngIf="isValidChannel"> - {{ruleSetDetails.name}}
            </span>
        </div>
        <div class="row">
            <div class="col-10">
                <pre class="narrative"><div [innerHTML]="queries | ruleNarrative: configs"></div></pre>
            </div>
            <div class="col-2">
                <button [disabled]="!ruleTesterEnabled()" kendoButton (click)="openRuleTester()"
                    class="with-margin float-right">
                    {{'RULE-TESTER' | translate}}
                </button>
            </div>
        </div>
    </div>
    <div class="content-background">
        <!--Sections-->
        <div *ngFor="let section of mainSections; let i = index">
            <div *ngIf="!section.hidden">
                <hr />
                <div style="margin-top:-10px;" class="k-text-uppercase dark mb-4 font-weight-bold">{{section.text}}
                </div>
                <div class="row" *ngIf="i <= 1">
                    <div class="col-md-1 rule-badge-container">
                        <span class="badge badge-pill badge-rule">
                            <i class="fas fa-lg" [ngClass]="section.icon"></i>
                        </span>
                    </div>
                    <app-query-builder class="col-md-11" [data]="queries[i]" [config]="configs[i]"
                        [disabled]="disableFormControl()" [classNames]='classNames'>
                    </app-query-builder>
                </div>
                <!--SubSections-->
                <div *ngIf="i > 1">
                    <div class="offset-5 mb-3">
                        <kendo-dropdownbutton *ngIf="!disableFormControl()"
                            [disabled]="subSectionsDropDown.length === 0" [data]="subSectionsDropDown"
                            (itemClick)="onSubSectionClick($event)">{{'ADD' | translate}}<kendo-svgicon class="ml-1"
                                [icon]="icons.caretDown"></kendo-svgicon>
                            <ng-template kendoDropDownButtonItemTemplate let-dataItem>
                                <div>
                                    <span class="sub-section-dropdown-icon fas {{dataItem.icon}} "></span>
                                    <span class="ml-2">{{dataItem.text}}</span>
                                </div>
                            </ng-template>
                        </kendo-dropdownbutton>
                    </div>
                    <div *ngFor="let subSection of subSections; let j = index">
                        <div *ngIf="!subSection.hidden && subSection.selected">
                            <div class="sub-section-title k-text-uppercase dark mb-2 mt-2">{{subSection.text}}
                                <span *ngIf="queries[j+i].rules.length === 0" title="{{'DELETE'|translate}}"
                                    (click)="removeSubSection(j)" style="position: relative;top: 3px;">
                                    <i class="fas fa-fw fa-times-circle fa-delete-custom"></i>
                                </span>
                            </div>
                            <div class="row">
                                <div class="col-md-1 rule-badge-container">
                                    <span class="badge badge-pill badge-rule">
                                        <i class="fas fa-lg" [ngClass]="subSection.icon"
                                            [ngStyle]="{'margin-left': subSection.iconLeftMargin }"></i>
                                    </span>
                                </div>
                                <app-query-builder class="col-md-11" [data]="queries[j+i]" [config]="configs[j+i]"
                                    [disabled]="disableFormControl()" [classNames]='classNames'></app-query-builder>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <hr />
        <button appPreventClick *ngIf="!disableFormControl()" kendoButton (click)="onSubmit($event, true)"
            class="with-margin float-right">
            {{'SAVE-AND-CLOSE' | translate}}
        </button>
        <button appPreventClick *ngIf="!disableFormControl()" kendoButton (click)="onSubmit($event, false)"
            class="with-margin float-right mr-3">
            {{'SAVE' | translate}}
        </button>
        <br /><br />
    </div>
</div>

<!--Rule Tester modal dialog-->
<app-channel-rule-tester [dialogOpened]="openedRuleTester" (closing)="closeRuleTester()" [queries]="queries"
    [ruleName]="ruleSetDetails?.name" [configs]="configs">
</app-channel-rule-tester>